import { z } from "zod";

/** E.164-style entry: leading +, then country/region code and number. */
export const enterpriseContactPhoneSchema = z
  .string()
  .trim()
  .min(1, "Phone number is required")
  .max(40, "Phone number is too long")
  .refine(
    (val) => /^\+[0-9\s\-().]{7,39}$/.test(val),
    {
      message:
        "Start with + and your country/region code, then the number (e.g. +852 9123 4567)",
    }
  );

export type EnterpriseContactPhone = z.infer<typeof enterpriseContactPhoneSchema>;
